export default {
      id: "presence-ooo-usage",
      viewBox: "0 0 10 10",
      url: "/dist/svg/" + "sprite.svg#presence-ooo-usage",
      toString: function () {
        return this.url;
      }
    }